import { render, staticRenderFns } from "./MatchTimeline.vue?vue&type=template&id=8cd092be&scoped=true"
import script from "./MatchTimeline.vue?vue&type=script&lang=js"
export * from "./MatchTimeline.vue?vue&type=script&lang=js"
import style0 from "./MatchTimeline.vue?vue&type=style&index=0&id=8cd092be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd092be",
  null
  
)

export default component.exports